module.exports = __webpack_public_path__ + "img/img_qrcode_only.a02c5747.png";